import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage, setMessageStatus } from "./messages";

import postService from "../services/posts.service";


export const createPost = createAsyncThunk(
    "create/posts",
    async (inputs, thunkAPI) => {
        try {
            const data = await postService.savePost(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const myPost = createAsyncThunk(
    "get/post",
    async (inputs, thunkAPI) => {
        try {
            const data = await postService.postList(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const singlePost = createAsyncThunk(
    "get/post-details",
    async (id, thunkAPI) => {
        try {
            const data = await postService.postDetails(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const deletePost = createAsyncThunk(
    "get/post-delete",
    async (id, thunkAPI) => {
        try {
            const data = await postService.postDelete(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const allPost = createAsyncThunk(
    "get/post-allposts",
    async (inputs, thunkAPI) => {
        try {
            const data = await postService.allPosts(inputs);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);

export const publicPost = createAsyncThunk(
    "get/post-public",
    async (id, thunkAPI) => {
        try {
            const data = await postService.postPublic(id);
            return { user: data.data.data };
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            thunkAPI.dispatch(setMessage(message));
            return thunkAPI.rejectWithValue();
        }
    }
);
const initialState = { posts: null, Status: "IDEL", post: null, allposts: null };

const postSlice = createSlice({
    name: "posts",
    initialState,
    // reducers: {
    //     reset: () => initialState
    // },
    extraReducers: {
        [createPost.fulfilled]: (state, action) => {
            state.Status = "Success";
        },
        [createPost.rejected]: (state, action) => {
            state.Status = "Failed";
        },
        [myPost.fulfilled]: (state, action) => {
            state.posts = action.payload.user;
        },
        [myPost.rejected]: (state, action) => {
            state.Status = "Failed";
            state.posts = null;
        },

        [singlePost.fulfilled]: (state, action) => {
            state.post = action.payload.user;
        },
        [singlePost.rejected]: (state, action) => {
            state.Status = "Failed";
            state.post = null;
        },
        [allPost.fulfilled]: (state, action) => {
            state.Status = "Success";
            state.allposts = action.payload.user;
        },
        [allPost.rejected]: (state, action) => {
            state.Status = "Failed";
            state.allposts = null;
        },
        [publicPost.fulfilled]: (state, action) => {
            state.post = action.payload.user;
        },
        [publicPost.rejected]: (state, action) => {
            state.Status = "Failed";
            state.post = null;
        },

    },
});

const { reducer } = postSlice;
export default reducer;
